<template>
  <div class="component-c225c07b">
    <div class="global-search-results" :class="`-mode-${$root.mode}`">
      <div class="container">
        <div class="row">
          <div class="col-sm-12">
            <search-form class="search-form"></search-form>

            <div
              class="search-results-container"
              :class="`-mode-${$root.mode}`"
            >
              <h3 class="results-description">
                <span>{{
                  $getTranslation("Results for", $route.params.region)
                }}</span>
                &ldquo;{{ query }}&rdquo;
              </h3>
              <!-- <p class="filter-instruction">
                Select a website below to filter:
              </p> -->

              <div>
                <div class="nav-bar">
                  <!-- <a
                    class="nav-bar-item"
                    :class="{ active: selectedTabType === 'en-in' }"
                    href="javascript:void(0);"
                    @click.prevent="selectTabType('en-in')"
                    >AU ({{ numResultsForTabType("en-in") }})</a
                  > -->
                  <!-- <a
                    class="nav-bar-item"
                    :class="{ active: selectedTabType === 'portable-oxygen' }"
                    href="javascript:void(0);"
                    @click.prevent="selectTabType('portable-oxygen')"
                    >Portable oxygen ({{
                      numResultsForTabType("portable-oxygen")
                    }})</a
                  >
                  <a
                    class="nav-bar-item"
                    :class="{ active: selectedTabType === 'ventilation' }"
                    href="javascript:void(0);"
                    @click.prevent="selectTabType('ventilation')"
                    >Ventilation ({{ numResultsForTabType("ventilation") }})</a
                  >
                  <a
                    class="nav-bar-item detached"
                    :class="{
                      active: selectedTabType === 'healthcare-professionals',
                    }"
                    href="javascript:void(0);"
                    @click.prevent="selectTabType('healthcare-professionals')"
                    >For healthcare professionals</a
                  >
                  <a
                    class="nav-bar-item detached"
                    :class="{ active: selectedTabType === 'resmed-corporate' }"
                    href="javascript:void(0);"
                    @click.prevent="selectTabType('resmed-corporate')"
                    >ResMed corporate</a
                  > -->
                </div>

                <div class="loading" v-if="loading">
                  <div class="spinner"></div>
                </div>

                <div v-if="error && !loading">
                  {{ error }}
                  <br />
                  <button type="button" @click="refreshResults()" class="ctaButton">
                    {{ $getTranslation("Retry", $route.params.region) }}
                  </button>
                </div>

                <slot name="healthcare-professionals"></slot>
                <div v-if="!error && !loading">
                  <!-- <div
                    v-if="
                      tabAwareResultGroup &&
                        numResultsForTabType(tabAwareResultGroup.type)
                    "
                    :key="tabAwareResultGroup.type"
                  > -->
                  <div
                    class="section-result-row-wrapper"
                    :key="section.type"
                    v-for="section in tabAwareResultGroup.sections"
                    v-if="section.results.length"
                  >
                    <h3 class="section-result-row-label">
                      <!-- {{ section.label }} -->
                      {{ $getTranslation(section.label, $route.params.region) }}
                    </h3>
                    <section-results
                      :section="
                        section.label === 'Documents'
                          ? getSectionItems(section)
                          : section
                      "
                    ></section-results>
                  </div>
                  <!-- </div> -->

                  <div v-if="shouldShowNoResultsForTabType(selectedTabType)">
                    <div class="no-results">
                      <eyebrow-icon
                        :eyebrowicon="{ icon: 'information', color: 'black' }"
                      ></eyebrow-icon>
                      <p class="note">
                        {{
                          $getTranslation(
                            "Search tips to consider:",
                            $route.params.region
                          )
                        }}
                      </p>
                      <ul>
                        <li>
                          {{
                            $getTranslation(
                              "Double check spelling",
                              $route.params.region
                            )
                          }}
                        </li>
                        <li>
                          {{
                            $getTranslation(
                              "Try using a less specific search term or different keyword",
                              $route.params.region
                            )
                          }}
                        </li>
                      </ul>
                    </div>
                  </div>

                  <div
                    v-if="
                      selectedTabType === 'resmed-corporate' &&
                        resmedCorporateAcf
                    "
                    class="resmed-corporate-tab-wrapper"
                  >
                    <component-de94ab88
                      :acf="resmedCorporateAcf"
                    ></component-de94ab88>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- this is only here so that the carousel can touch the browser window edges on mobile views -->
    <div
      v-if="
        selectedTabType === 'healthcare-professionals' &&
          healthcareProfessionalsAcf
      "
      class="healthcare-professionals-tab-wrapper"
      :class="`-mode-${$root.mode}`"
    >
      <component-e505c56b
        :acf="healthcareProfessionalsAcf"
      ></component-e505c56b>

      <div class="healthcare-professionals-bottom-callout">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <hr />
              <h3>Search the healthcare professionals website</h3>
              <a
                :href="healthcareProfessionalsWebsiteUrl"
                class="btn cta-pill filled-red icon search ctaButton"
                >{{ $getTranslation("Search", $route.params.region) }}</a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UrlHelpers from "../../mixins/url-helpers";
import Paginate from "vuejs-paginate";
import SectionResults from "../shared-support/search/section-results";
import ComponentDe94ab88 from "./component-de94ab88";
import { mapMutations } from "vuex";

const SECTION_RESULT_GROUP_TYPES = [
  localStorage
    .getItem("siteUrl")
    .split("/")
    .pop(),
  //   "sleep-apnea",
  //   "portable-oxygen",
  //   "ventilation",
];

export default {
  name: "component-c225c07b", // global_search_results
  props: [
    "resmedCorporateAcf",
    "healthcareProfessionalsAcf",
    "healthcareProfessionalsWebsiteUrl",
  ],
  created() {
    this.setShowLinks(true);
    bus.$emit("navigation:reversed", true);
    bus.$emit("navigation:search-disabled", true);

    this.refreshResults();
  },
  mixins: [UrlHelpers],
  components: { ComponentDe94ab88, Paginate, SectionResults },
  data() {
    const pathParts = location.pathname
      .split("/")
      .filter((p) => p)
      .slice(0, 2);

    return {
      slider: null,
      loading: false,
      selectedTabType: SECTION_RESULT_GROUP_TYPES.includes(pathParts[1])
        ? pathParts[1]
        : // : localStorage.getItem("siteUrl").split("/").pop(),
          process.env.VUE_APP_API_ENDPOINT.split("/").pop(),
      query: this.getQueryStringParameter("rmsq", ""),
      category: this.getQueryStringParameter("cat", ""),
      resultGroups: [],
    };
  },
  computed: {
    resultsPerPage() {
      return 4;
    },
    tabAwareResultGroup() {
      return this.getResultGroupByType(this.selectedTabType);
    },
  },
  methods: {
    ...mapMutations(["setShowLinks"]),

    getSectionItems(section) {
      let newSection = [];
      const role = this.$cookies.get("role");
      const categoryCookie = $cookies.get("categories");

      try {
        if (
          (categoryCookie == "" || categoryCookie == null) &&
          (role != "" || role != null)
        ) {
          this.$cookies.set(
            "categories",
            role && role.replace(/approved/g, "approve"),
            null,
            "/",
            window.location.hostname.includes(".resmed.com")
              ? ".resmed.com"
              : "localhost"
          );
        }
      } catch (error) {
        console.log(error);
      }
      const email = this.$cookies.get("rocEmail");

      if (section && section.results) {
        section.results.map((item) => {
          if (!item.files || !item.files.length) {
            return;
          }

          const doc = item.files[0].file;

          if (doc) {
            if (doc.includes("/secure")) {
              if (
                doc.includes("/secure/tsp") &&
                email &&
                email.includes("@resmed.") &&
                role &&
                role.includes("technical_approved")
              ) {
                newSection.push(item);
              } else if (
                doc.includes("/secure/tsp") &&
                email &&
                !email.includes("@resmed.") &&
                role &&
                role.includes("technical_approved") &&
                item.availability == "false"
              ) {
                newSection.push(item);
              } else if (!doc.includes("/secure/tsp")) {
                newSection.push(item);
              }
            } else {
              newSection.push(item);
            }
          }
        });
        return { ...section, results: newSection };
      }
    },

    shouldShowNoResultsForTabType(type) {
      if (SECTION_RESULT_GROUP_TYPES.includes(type)) {
        return !this.numResultsForTabType(type);
      } else if (type === "healthcare-professionals") {
        return !this.healthcareProfessionalsAcf;
      } else if (type === "resmed-corporate") {
        return !this.resmedCorporateAcf;
      }

      return true;
    },
    selectTabType(tab) {
      this.selectedTabType = tab;
    },
    getResultGroupByType(type) {
      const resultGroup = this.resultGroups.filter((rg) => rg.type === type);

      console.log("resultgroup", resultGroup);

      if (resultGroup.length) {
        return resultGroup[0];
      }

      return null;
    },
    numResultsForTabType(type) {
      const resultGroup = this.getResultGroupByType(type);
      return resultGroup
        ? resultGroup.sections.reduce(
            (amount, section) => (amount += section.results.length),
            0
          )
        : 0;
    },
    refreshResults() {
      if (this.loading) {
        return;
      }

      this.loading = true;
      this.error = "";

      // const site = localStorage.getItem("siteUrl").split("/").pop();
      axios({
        url: `${process.env.VUE_APP_GSSPOD_ENPOINT}/graphql`,
        method: "post",
        data: {
          query: `
              query {
            search(region: "${this.$route.params.region}", key: "${
            this.query
          }", cat:"${this.category !== "all" ? this.category : ""}")
          }
            `,
        },
      })
        .then((response) => {
          // On error return to catch
          if (response.data.errors) {
            throw new Error(response.data.errors[0].message);
          }

          this.resultGroups = response.data.data.search;
          // console.log("response.dtx", this.resultGroups);
          // if (
          //   !SECTION_RESULT_GROUP_TYPES.reduce(
          //     (s, t) => s + this.numResultsForTabType(t),
          //     0
          //   )
          // ) {
          //   this.selectedTabType = localStorage
          //     .getItem("siteUrl")
          //     .split("/")
          //     .pop();
          // }
          this.selectedTabType = this.$route.params.region;
          // console.log("tab type", this.selectedTabType);
        })
        .catch((error) => {
          this.error = this.$getTranslation(
            "An error occurred loading your search results",
            this.$route.params.region
          );
        })
        .then(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/abstracts/path";
@import "../../css/abstracts/colors";
@import "../../css/base/typography";

.global-search-results {
  padding-top: 9.75rem;

  &.-mode-xs,
  &.-mode-sm,
  &.-mode-md {
    padding-top: 0;
    margin: 2.0625rem;
  }
}

.no-results {
  margin-top: 5.6875rem;
  margin-bottom: 5.625rem;

  .note {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 700;
    position: relative;
    @extend %eyebrow-left;
  }

  ul {
    margin-left: 1.2em;
  }
}

.loading {
  padding: 2rem 2rem 4rem 2rem;

  .spinner {
    margin: 0 auto;
  }
}

.search-results-container {
  margin-top: 3.375rem;
  margin-bottom: 3.375rem;

  .results-description {
    span {
      font-family: "Plus Jakarta Sans", sans-serif;
      font-weight: 500;
    }
  }

  .filter-instruction {
    font-size: 0.75rem;
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 700;
    line-height: 1.92;
    letter-spacing: -0.21px;
  }

  &.-mode-md,
  &.-mode-sm,
  &.-mode-xs {
    .nav-bar {
      flex-direction: column;
      align-items: flex-start;
      margin-bottom: 0;

      .nav-bar-item::after {
        background-color: transparent;
        margin-top: 0.375rem;
      }

      .nav-bar-item:not(.active) {
        color: $cc-resmed-grey-30;
      }
    }
  }

  .section-result-row-wrapper {
    padding: 2.8125rem 0;
    border-bottom: 1px solid $cc-resmed-grey-30;

    &:last-child {
      border-bottom: 0;
    }

    .section-result-row-label {
      margin-bottom: 0;
    }
  }
}

.nav-bar {
  margin: 0 -0.625rem 2.8125rem -0.625rem;
  display: flex;

  .nav-bar-item {
    font-family: "Plus Jakarta Sans", sans-serif;
    font-weight: 700;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.31;
    letter-spacing: normal;
    color: $cc-resmed-black;
    position: relative;
    margin: 0.625rem;

    &::after {
      transition: all 0.3s;
      position: absolute;
      margin-top: 0.625rem;
      height: 1px;
      background-color: $cc-resmed-grey-30;
      content: " ";
      left: 0;
      top: 100%;
      width: 100%;
    }

    &:hover,
    &.active {
      &::after {
        height: 2px;
        background-color: $cc-resmed-hero-blue !important;
      }
    }
  }
}

.healthcare-professionals-tab-wrapper {
  margin-top: -3rem;
}

.healthcare-professionals-bottom-callout {
  text-align: center;
  // margin-top: -3rem;
  margin-left: 2.0625rem;
  margin-right: 2.0625rem;
  margin-bottom: 3rem;

  h3 {
    margin-top: 3rem;
  }

  hr {
    border-top-color: $cc-resmed-grey-30;
  }
}
</style>

<style lang="scss">
.healthcare-professionals-tab-wrapper {
  &.-mode-xs,
  &.-mode-sm,
  &.-mode-md {
    .component-e505c56b {
      padding-top: 0;
    }

    .headline-text {
      padding-top: 0 !important;
      padding-left: 3.5rem;
      padding-right: 3.5rem;
    }
  }
}
</style>
